import makeStyles from "@mui/styles/makeStyles";
import { DrawerProps } from "./Drawer.types";

export const useDrawerStyles = makeStyles({
  paper: (props: DrawerProps) => ({
    display: "block",
    width: props.fullWidth ? "100%" : undefined,
  }),
});
